module.exports = __webpack_public_path__ + "media/images/games/k2gender/qimg2-81feae4a792a542c148ff9f8e10f6ffc.png";